
import {apiUrl, apiParams} from "@/const/const"
import dateFormat from 'vux/src/tools/date/format.js'

import MyBtnReturn from "@/components/subComponents/MyBtnReturn";

export default {
name: 'LoadImgList',
components: {
MyBtnReturn
},
data() {
return {
src1: require('@/assets/images/plan/wx_zhuang_blue.png'), // 装箱的图片
src2: require('@/assets/images/plan/wx_chai_oringe.png'), // 拆箱的图片
tableData: [],
isShowTable: true,
isShowLoading: false,
isNoData: false,
}
},
created() {
document.title = '装货图片';
this.getData()
},
methods: {
getData() {
let data = {
openId: apiParams.openId,
companyId: apiParams.companyId,
code: apiParams.code,
};
this.isShowLoading = true;

this.requestApi({
url: apiUrl.loadImgListController,
data: data
}, (resultData) => {
let list = resultData.data.list || [];
if (list.length === 0) {

this.isNoData = true;
this.isShowLoading = false;
this.isShowTable = false;
return
}
this.tableData = list;
}, (error) => {
this.isShowLoading = false;
if (error) {
console.error(error); 
}
})
},
goNextPage(bookingId, ladingId, servicetype) {

this.$router.push({
name: 'LoadImgLading',
query: {
bookingId: bookingId,
ladingId: ladingId,
servicetype: servicetype,
}
})
},
dateFormat(time) {
return dateFormat(time, 'YYYY-MM-DD HH:mm')
}
}
}



// WEBPACK FOOTER //
// ./src/components/siji/loadImg/LoadImgList.vue